import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  SortingOption,
  SortingOptionEnum,
  SortingState,
} from '../../../../../interfaces/src/lib/types/index';

const initialState: SortingState = {
  cabinTypeSorter: {
    optionLabel: 'Relevance',
    optionValue: SortingOptionEnum.Relevance,
  },
};

const cabinTypeSorterSlice = createSlice({
  name: 'cabinTypeSorter',
  initialState,
  reducers: {
    setSortingState: (state, action: PayloadAction<SortingOption>) => {
      state.cabinTypeSorter = action.payload;
    },
  },
});

export const { setSortingState } = cabinTypeSorterSlice.actions;
export default cabinTypeSorterSlice.reducer;
